import { useCallback, useEffect, useState } from "react";

// Extend the Window interface to include grecaptcha
declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void;
      execute: (
        siteKey: string,
        options: { action: string }
      ) => Promise<string>;
    };
  }
}

const useRecaptchaV3 = (siteKey: string) => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);

  useEffect(() => {
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => setIsRecaptchaReady(true));
    } else {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => setIsRecaptchaReady(true));
        }
      };
    }
  }, [siteKey]);

  const executeRecaptcha = useCallback(
    async (action: string) => {
      if (isRecaptchaReady && window.grecaptcha) {
        return await window.grecaptcha.execute(siteKey, { action });
      }
      return null;
    },
    [isRecaptchaReady, siteKey]
  );

  return { executeRecaptcha, isRecaptchaReady };
};

export default useRecaptchaV3;
